import { getRecaptchaKey } from './server-util';

/**
 * Executes an invisible reCAPTCHA v3 challenge and resolves with the resulting token, if the
 * grecaptcha script has loaded. Resolves with an empty string otherwise.
 *
 * @param {string} [action] The reCAPTCHA action name to report.
 */
export async function executeRecaptcha(action = 'submit') {
  if (!window.grecaptcha) {
    return '';
  }

  return new Promise((resolve) => {
    window.grecaptcha.ready(async () => {
      resolve(await window.grecaptcha.execute(getRecaptchaKey(), { action }));
    });
  });
}
